<template>
  <div class="container-fluid">
    <div class="row no-gutter">
      <!-- The image half -->
      <div class="col-md-6 d-none d-md-flex bg-image"></div>
      <div id="form" v-on:submit.prevent="login1()" class="col-md-6">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 col-xl-7 mx-auto">
                <img id="logo" src="../assets/nearcode_cut.png" alt="" />
                <p class="text-muted mb-4"></p>
                <form>
                  <div class="form-group mb-3">
                    <input
                      id="inputEmail"
                      type="email"
                      placeholder="Email address"
                      required
                      autofocus=""
                      v-model="emailLogin"
                      class="form-control rounded-pill border-0 shadow-sm px-4"
                    />
                  </div>
                  <div class="form-group mb-3">
                    <input
                      id="inputPassword"
                      type="password"
                      placeholder="Password"
                      required
                      v-model="passwordLogin"
                      class="form-control rounded-pill border-0 shadow-sm px-4 text-primary"
                    />
                  </div>
                  <p>Se não tens conta fala com o adminstrador da plataforma</p>
                  <button
                    id="entrar"
                    type="submit"
                    class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm"
                  >
                    Entrar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({ emailLogin: "", passwordLogin: "" }),
  methods: {
    async login1() {
      try {
        await this.$store.dispatch("login", {
          email: this.emailLogin,
          password: this.passwordLogin,
        });
      } catch (err) {
        if (err === "TypeError: Failed to fetch") {
          this.$swal({
            title: "FAIL TO FETCH!",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!",
          });
        } else {
          this.$swal({
            title: err.data[0].message,
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!",
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.login,
.image {
  min-height: 100vh;
}
#logo {
  max-height: 150px;
}

.bg-image {
  background-image: url("../assets/back.jpg");
  background-size: cover;
  background-position: center center;
}

#entrar {
  background: #f7941e;
  border: hidden;
}
#form {
  background: #888888;
}
p {
  font-size: 15px;
  color: rgba(245, 245, 245, 0.664);
}
</style>
